// https://gist.github.com/john-doherty/bcf35d39d8b30d01ae51ccdecf6c94f5

/**
 * wraps a promise in a timeout, allowing the promise to reject if not resolve with a specific period of time
 * @param {integer} ms - milliseconds to wait before rejecting promise if not resolved
 * @param {Promise} promise to monitor
 * @Example
 *  promiseTimeout(1000, fetch('https://courseof.life/johndoherty.json'))
 *      .then(function(cvData){
 *          alert(cvData);
 *      })
 *      .catch(function(){
 *          alert('request either failed or timedout');
 *      });
 */
export const promiseTimeout = (ms, promise) => {
    return new Promise((resolve, reject) => {
        // create a timeout to reject promise if not resolved
        const timer = setTimeout(() => {
            reject();
        }, ms);

        promise
            .then(res => {
                clearTimeout(timer);
                resolve(res);
            })
            .catch(err => {
                clearTimeout(timer);
                reject(err);
            });
    });
};
